import MaskedInput from "react-text-mask"

const N = /\d/

export const cnpjMask = [N, N, ".", N, N, N, ".", N, N, N, "/", N, N, N, N, "-", N, N]
export const cepMask = [N, N, N, N, N, "-", N, N, N]
export const telefoneMask = ["(", N, N, ")", " ", N, N, N, N, N, "-", N, N, N, N]

export const MascaraCNPJ = props => {
    const { inputRef, ...rest } = props
    return (
        <MaskedInput
            {...rest}
            ref={ref => inputRef(ref ? ref.inputElement : null)}
            mask={cnpjMask}
            placeholderChar={" "}
            guide={false}
        />
    )
}

export const MascaraCEP = props => {
    const { inputRef, ...rest } = props
    return (
        <MaskedInput
            {...rest}
            ref={ref => inputRef(ref ? ref.inputElement : null)}
            mask={cepMask}
            placeholderChar={" "}
            guide={false}
        />
    )
}

export const MascaraTelefone = props => {
    const { inputRef, ...rest } = props
    return (
        <MaskedInput
            {...rest}
            ref={ref => inputRef(ref ? ref.inputElement : null)}
            mask={telefoneMask}
            placeholderChar={" "}
            guide={false}
        />
    )
}

export const CATEGORIAS = [
    "Variado",
    "Restaurante",
    "Lanchonete",
    "Hamburgueria",
    "Pizzaria",
    "Cafeteria",
    "Açaiteria",
    "Assados",
    "Doceria",
    "Sorveteria",
    "Comida Oriental",
    "Creperia",
    "Livraria",
    "Embalagens",
    "Outros",
]

export const PLANOS = [
    { value: "PLANO1", label: "Plano 1" },
    { value: "PLANO1_DESCONTO", label: "Plano 1 (Desconto)" },
    { value: "PLANO2", label: "Plano 2" },
    { value: "PLANO3", label: "Plano 3" },
    { value: "PLANO4", label: "Plano 4" },
]

export const MAX_LOGO_BYTES = 2 * 1024 * 1024
export const MIME_LOGO_ACEITOS = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/gif",
    "image/webp",
    "image/bmp",
    "image/tiff",
    "image/svg+xml",
    "image/heif",
    "image/avif",
]
